module.exports = __webpack_public_path__ + "static/media/restful.1f7e0e92.svg";